export default {"src":"/_next/static/media/consumables.be97113e.svg","height":19,"width":22,"blurWidth":0,"blurHeight":0};